//
//
//
//
//
//
//
//

import QRCode from 'qrcodejs2'
import { queryUserInfo } from '@/https/user'

export default {
  data () {
    return { userData: {} }
  },

  async created () {
    await this.getUserData()
    const width = (document.body.offsetWidth * 0.8 || 250) - 40

    new QRCode('qrcode', {
      width,
      height: width,
      text: this.userData.zjhm,
    })
  },

  methods: {
    async getUserData () {
      const { data } = await queryUserInfo()
      this.userData = data || {}
    },
  },
}
